//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sortBy } from 'lodash-es';
import lastModified from './last-modified';
import fractionToDecimal from '~/utils/fraction-to-decimal';
export default {
  components: {
    lastModified,
  },
  data: () => ({
    utc: false,
    socials: [],
    contact: [],
    nav1: [],
    nav2: [],
  }),
  async fetch() {
    const socials = await this.$content('socials').fetch();
    const contact = await this.$content('contact').fetch();
    const navData = (
      await this.$content('pages').where({ show_footer: true }).fetch()
    ).map((item) => ({
      ...item,
      pos: fractionToDecimal(item.pos),
    }));
    const nav = sortBy(navData, ['show_tab', 'pos']);
    const navHalf = Math.ceil(nav.length / 2);
    const nav1 = nav.slice(0, navHalf);
    const nav2 = nav.slice(-navHalf);

    const data = {
      contact,
      socials,
      nav1,
      nav2,
    };
    Object.assign(this.$data, data);
  },
  fetchKey: 'layout/footer',
  methods: {
    shortHash: (value) => (value ? value.substring(0, 7) : null),
  },
};
